import { KitchenService} from '../../../../../services/KitchenService/KitchenService';
import { ISaveBottomUnitData } from '../../../../../../../common-code/interfaces/saveData/ISaveBottomUnitData';
import { ThreeBottomUnit } from '../ThreeBottomUnit';
import { ISaveCorpusData } from 'common-code/lib/interfaces/saveData/ISaveCorpusData';
import { CommonHelper } from 'common-code';
import { ThreeBottomDoubleHoleHandleUnitCorpus } from '../../../details/ThreeCorpus/types/ThreeBottomDoubleIntegratedHandleUnitCorpus';

export class ThreeBottomDoubleHoleHandleUnit extends ThreeBottomUnit {
    corpus: ThreeBottomDoubleHoleHandleUnitCorpus;

    constructor(options: ISaveBottomUnitData, service: KitchenService) {
        super(options, service);
        this.corpus = this.initCorpus(options.corpus);
    }

    protected initCorpus(corpusData: ISaveCorpusData): ThreeBottomDoubleHoleHandleUnitCorpus {
        return new ThreeBottomDoubleHoleHandleUnitCorpus(CommonHelper.deepCopy(corpusData), this)
    }
}